import {ExportType} from 'config-migration/types/ExportType';
import {ConfigMigrationAnalyticsAction} from 'constants/AnalyticsConstants';

import {
  BaseConfigMigrationEventMetadata,
  CompletedTimedConfigMigrationEventMetadata,
  trackConfigMigrationEvent,
} from './CommonConfigMigrationAnalytics';

// Metadata
export interface ExportOrganizationEventMetadata {
  export_type: ExportType;
  selected_object_count?: number;
  exported_object_count?: number;
  exported_object_count_by_type?: Record<string, number>;
}

// Export Functions
export function trackInitiatedExportOrganizationConfig(
  metadata: BaseConfigMigrationEventMetadata & ExportOrganizationEventMetadata
): void {
  trackConfigMigrationEvent(ConfigMigrationAnalyticsAction.INITIATED_EXPORT_ORGANIZATION_CONFIG, metadata);
}

export function trackCompletedExportOrganizationConfig(
  metadata: CompletedTimedConfigMigrationEventMetadata & ExportOrganizationEventMetadata
): void {
  trackConfigMigrationEvent(ConfigMigrationAnalyticsAction.COMPLETED_EXPORT_ORGANIZATION_CONFIG, metadata);
}
